<template>
  <el-dropdown trigger="click" class="gear-menu" @command="$emit('command', $event)">
    <button class="toolbar-btn toolbar-btn--icon" :title="title">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        class="gear-menu__icon"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    </button>
    <el-dropdown-menu slot="dropdown" class="gear-menu__popper">
      <slot />
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui';

export default {
  name: 'GearMenu',
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem
  },
  props: {
    title: { type: String, default: 'More actions' }
  }
};
</script>

<style lang="scss" scoped>
// `.toolbar-btn` was previously defined per-view in each consumer's scoped
// styles. When the button moved into this shared component, those styles no
// longer applied. Replicate here so the button looks identical across views.
.toolbar-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: rgba(255, 255, 255, 0.3);
  }

  &--icon {
    padding: 6px;
    position: relative;
  }
}

.gear-menu__icon {
  width: 18px;
  height: 18px;
}

// Light mode
.white-content {
  .toolbar-btn {
    color: rgba(52, 70, 117, 0.8);
    border-color: rgba(52, 70, 117, 0.2);

    &:hover {
      background: rgba(52, 70, 117, 0.05);
      color: #344675;
      border-color: rgba(52, 70, 117, 0.35);
    }
  }
}
</style>

<style lang="scss">
// Teleported popper — targeted via class on el-dropdown-menu which Vue merges
// onto the root <ul>. Element UI's `i { margin-right: 5px }` handles tim-icons,
// but b-icon renders as <svg> and needs its own spacing.
.gear-menu__popper.el-dropdown-menu {
  .el-dropdown-menu__item > svg {
    margin-right: 5px;
  }

  // Neutral hover/focus — overrides Element UI's primary-color default.
  // !important needed because Element UI's rule has equal specificity and
  // can load after component-injected styles.
  .el-dropdown-menu__item:not(.is-disabled) {
    &:hover,
    &:focus,
    &.hover {
      background-color: rgba(0, 0, 0, 0.06) !important;
      color: inherit !important;
    }
  }
}

// Mobile: bump touch target to iOS-recommended 44px, preserve Element UI's
// 36px desktop line-height for other sizes.
@media (max-width: 768px) {
  .gear-menu__popper.el-dropdown-menu .el-dropdown-menu__item {
    line-height: 44px;
    padding: 0 20px;
  }
}
</style>
